module.exports = __webpack_public_path__ + "img/discord-white.145dc557.svg";